'use client';

import React from 'react';
import HeroSection from '@/components/HeroSection';
import TopBar from '@/components/TopBar';
import Navbar from '@/components/Navbar';
import AboutSection from '@/components/AboutSection';
import WhyUsSection from '@/components/WhyUsSection';
import ServicesSection from '@/components/ServicesSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import FloatingCTA from '@/components/FloatingCTA';
import StatsSection from '@/components/StatsSection';
import TestimonialsSection from '@/components/TestimonialsSection';

export default function Home() {
  return (
    <main className="bg-[#0c0b09] text-white overflow-x-hidden">
      <TopBar />
      <Navbar />
      <HeroSection />
      <StatsSection />
      <AboutSection />
      <WhyUsSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <FloatingCTA />
    </main>
  );
}
